export default __webpack_public_path__ + "db507a88449965dd7504c800553aa5d8.png";